import { usePageVisibility } from "react-page-visibility";

export const OnPageVisible = (props) => {
  const isPageVisible = usePageVisibility();

  return isPageVisible ? props.children : null;
};

export default OnPageVisible;
